import { render, staticRenderFns } from "./SoftwareCategoryAwards.vue?vue&type=template&id=3760ba6c&scoped=true"
import script from "./SoftwareCategoryAwards.vue?vue&type=script&setup=true&lang=ts"
export * from "./SoftwareCategoryAwards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SoftwareCategoryAwards.vue?vue&type=style&index=0&id=3760ba6c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3760ba6c",
  null
  
)

export default component.exports